import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-313a2406"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-widget-state" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-widget-state__loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-widget-state__spinner" }, null, -1))
const _hoisted_4 = { class: "dashboard-widget-state__text" }
const _hoisted_5 = {
  key: 1,
  class: "dashboard-widget-state__empty"
}
const _hoisted_6 = { class: "dashboard-widget-state__title" }
const _hoisted_7 = { class: "dashboard-widget-state__text" }
const _hoisted_8 = {
  key: 2,
  class: "dashboard-widget-state__error"
}
const _hoisted_9 = { class: "dashboard-widget-state__title" }
const _hoisted_10 = { class: "dashboard-widget-state__text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetState',
  props: {
    variant: {},
    loadingText: { default: 'Đang tải dữ liệu...' },
    emptyTitle: { default: 'Không có dữ liệu' },
    emptyText: { default: 'Chưa có dữ liệu để hiển thị cho phạm vi hiện tại.' },
    errorTitle: { default: 'Không tải được dữ liệu' },
    errorText: { default: 'Vui lòng thử lại sau hoặc kiểm tra kết nối mạng.' },
    showRetry: { type: Boolean, default: true }
  },
  emits: ["retry"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.variant === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.loadingText), 1)
        ]))
      : (_ctx.variant === 'empty')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.emptyTitle), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.emptyText), 1)
          ]))
        : (_ctx.variant === 'error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.errorTitle), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.errorText), 1),
              (_ctx.showRetry)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-light-primary mt-3",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
                  }, " Thử lại "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})